export class SearchField {
  constructor(public name: string, public placeholder: string, public type: string = 'text') {}
}
